export function HelpersUserJavascript (pEditor, pHelpers)
{
  var scripts = [],
      scriptAttributeList =
      [
        'language',
        'type',
        'data-id',
        'data-format',
        'data-related',
        'data-jobId',
        'data-companyId',
        'data-companyName',
        'data-jobTitle',
        'data-jobLocation',
        'data-email',
        'data-url',
        'data-urlFormat',
        'data-onclick',
        'data-onsuccess',
        'data-logo',
        'data-phone',
        'data-coverLetter',
        'data-showText',
        'data-meta',
        'data-themeColor',
        'data-questions',
        'data-onResize',
        'data-size'
      ];


  this.collect = (content, isRestore, isSelectively) =>
  {
    if (!content.match(/<script(?:\s[^>]*>|>)/i))
    {
      return content;
    }

    var i, n, fragment, elements, scriptContent;
    var userScriptIndex;
    var copyElements = [];
    var scriptsWithSrc, matchSrc, copySrcIndex;
    var copySrc = [];
    var cloneJsVisualTag;
    var jsVisualTag = document.createElement('IMG');
    jsVisualTag.src = '/Admin/html_res/images/editor-in-script.gif';
    jsVisualTag.border = '0';
    jsVisualTag.style.border = '0';
    jsVisualTag.style.border = 'none';
    jsVisualTag.style.background = 'none';
    jsVisualTag.style.padding = '0';
    jsVisualTag.style.margin = '0';

    if (!isSelectively)
    {
      scripts = [];
    }

    userScriptIndex = scripts.length;
    scriptsWithSrc = content.match(/<script\s+[^>]*src\s*=\s*(['"]?)[^\s>]+(?=\1|\s|>)/ig);

    if (scriptsWithSrc)
    {
      for (i = 0; i < scriptsWithSrc.length; i++)
      {
        matchSrc = scriptsWithSrc[i].match(/\ssrc\s*=\s*(['"]?)([^\s>]+)(?=\1|\s|>)/i);

        if (matchSrc && matchSrc.length > 2)
        {
          copySrc.push(matchSrc[2]);
        }
      }
    }

    fragment = pEditor.iFrameDoc.createElement('DIV');
    fragment.innerHTML = (BEditor.browser.isIE) ? '.<!--###S*D*A*S*M*A*S*G*D=F3773A+CCAFDA###-->' + content : content;
    elements = fragment.getElementsByTagName('SCRIPT');

    for (i = 0; i < elements.length; i++)
    {
      if (!elements[i].getAttribute('keepercontainerforformmodule'))
      {
        copyElements.push(elements[i]);
      }
      else
      {
        elements[i].parentNode.removeChild(elements[i]);
        i--;
      }
    }

    copySrcIndex = 0;

    for (i = 0; i < copyElements.length; i++)
    {
      scripts[userScriptIndex] = {};

      for (n = 0; n < scriptAttributeList.length; n++)
      {
        if (copyElements[i].getAttribute(scriptAttributeList[n]))
        {
          scripts[userScriptIndex][scriptAttributeList[n]] = copyElements[i].getAttribute(scriptAttributeList[n]);
        }
      }

      if (copyElements[i].getAttribute('src'))
      {
        scripts[userScriptIndex].src = copySrc[copySrcIndex++];
      }

      scriptContent = copyElements[i].innerHTML;

      if (isRestore && scriptContent.match(/^\s*try\s*\{\s*(?:(?:.|[\n\r])*?)\s*}\s*catch\s*\(\s*e\s*\)\s*\{\s*}\s*$/i))
      {
        scriptContent = scriptContent.replace(/^\s*try\s*\{[ \t]*[\n\r]?((?:.|[\n\r])*?)[\n\r]?[ \t]*}\s*catch\s*\(\s*e\s*\)\s*\{\s*}\s*$/i, '$1');
      }

      if (BEditor.browser.isIE)
      {
        scriptContent = scriptContent.replace(/^[\n\r]*((?:.|[\n\r])*?)[\n\r]*$/i, '$1');
      }

      scripts[userScriptIndex].content = scriptContent;
      cloneJsVisualTag = jsVisualTag.cloneNode(false);
      cloneJsVisualTag.alt = 'UserCustomScript-' + userScriptIndex;
      copyElements[i].parentNode.replaceChild(cloneJsVisualTag, copyElements[i]);
      userScriptIndex++;
    }

    content = fragment.innerHTML;
    content = (BEditor.browser.isIE) ? content.replace(/\.<!--\s*###S\*D\*A\*S\*M\*A\*S\*G\*D=F3773A\+CCAFDA###\s*-->/ig, '') : content;

    return content;
  };


  this.restore = (content, isSave) =>
  {
    content = content.replace(/<img\s[^>]*alt=['"]?UserCustomScript-(\d+)['"]?[^>]*>/ig, function(str, num)
      {
        var i, ret;
        num = parseInt(num);

        if (!isNaN(num) && scripts[num])
        {
          ret = '<script';

          for (i = 0; i < scriptAttributeList.length; i++)
          {
            if (scripts[num][scriptAttributeList[i]])
            {
              ret += ' ' + scriptAttributeList[i] + '="' + scripts[num][scriptAttributeList[i]] + '"';
            }
          }

          ret += (scripts[num].src) ? ' src="' + scripts[num].src + '"' : '';
          ret += '>';
          ret += (isSave && !scripts[num].src) ? 'try { \n' : ((BEditor.browser.isIE) ? '\n' : '');
          ret += scripts[num].content;
          ret += (isSave && !scripts[num].src) ? '\n } catch(e) {}' : ((BEditor.browser.isIE) ? '\n' : '');
          ret += '</script>';

          return ret;
        }
        else
        {
          return '';
        }
      }
    );

    return content;
  };


  this.getIndex = () =>
  {
    var currentSelection = pEditor.range.selection.getCurrent();
    var currentRange = pEditor.range.getCurrent();
    var currentElement;
    var scriptIndex;
    var ret = null;

    if (BEditor.browser.isIE)
    {
      if (currentSelection.type.toUpperCase() == 'CONTROL' && currentRange.length == 1 &&
          currentRange.item(0).nodeName.toUpperCase() == 'IMG' && currentRange.item(0).getAttribute('alt') &&
          currentRange.item(0).getAttribute('alt').toLowerCase().indexOf('usercustomscript-') != -1)
      {
        scriptIndex = parseInt(currentRange.item(0).getAttribute('alt').match(/\d+/));
        ret = (!isNaN(scriptIndex) && scripts[scriptIndex]) ? scriptIndex : null;
      }
    }
    else
    {
      if (currentRange.startContainer == currentRange.endContainer &&
          currentRange.endOffset - currentRange.startOffset < 2 && currentRange.startContainer.hasChildNodes())
      {
        currentElement = currentRange.startContainer.childNodes[currentRange.startOffset];

        if (currentElement &&
          currentElement.nodeName.toUpperCase() == 'IMG' &&
          currentElement.getAttribute('alt') &&
          currentElement.getAttribute('alt').toLowerCase().indexOf('usercustomscript-') != -1)
        {
          scriptIndex = parseInt(currentElement.getAttribute('alt').match(/\d+/));
          ret = (!isNaN(scriptIndex) && scripts[scriptIndex]) ? scriptIndex : null;
        }
      }
    }

    return ret;
  };


  this.isSelected = () =>
  {
    return (this.getIndex() != null);
  };


  Object.defineProperty(this, 'scripts', { get: () => scripts});
}